// test2489
(2489 && 0);
